module.exports = __webpack_public_path__ + "static/img/logo-fendi.fbb619f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-fendi.png
// module id = z3xB
// module chunks = 1